import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "docfile" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "size" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FileIcon = _resolveComponent("FileIcon")
  const _component_Ellipsis = _resolveComponent("Ellipsis")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FileIcon, {
      painted: "",
      "font-size": "0.9rem",
      ext: $props.file.ext,
      class: "icon"
    }, null, 8 /* PROPS */, ["ext"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Ellipsis, { class: "name" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($options.name), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, _toDisplayString($options.size), 1 /* TEXT */)
    ])
  ]))
}